import { getApiUrl } from '../../utils/api';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Icone360 } from '../kit/Icones360';
import { Notifications42 } from '../lot42/Lot42Sheets';
import '../accueil/familles-fil.css';
import { useNavModules } from './useNavModules';
import './mobile-gabarit.css';

/* M3 · compteur crédits de l'en-tête mobile : le même chiffre que Réglages et Crédits · « 62 » + badge + barre · jamais « Crédits 260 » · tap = la page Crédits */
export const CompteurCredits = ({ testId = 'mg-credits' }) => {
  const navigate = useNavigate();
  const { tenantSlug } = useParams();
  const d = useNavModules();
  const [b, setB] = useState(null);
  useEffect(() => { if (d?.credits) return; axios.get(`${getApiUrl()}/credits/balance`, { withCredentials: true }).then((r) => setB({ solde: r.data.balance, free: r.data.free, par_mois: r.data.plans?.[r.data.plan]?.credits_month, renouvellement_label: '' })).catch(() => {}); }, [d?.credits]);
  const c = d?.credits || b;  // LOT 46 v2 · D1 · le compteur affiche toujours son nombre (repli : le solde du journal)
  if (!c) return <span className="mg-cnt is-vide" aria-hidden="true" />;
  return (
    <button type="button" className={`mg-cnt ${!c.free && c.solde <= 0 ? 'is-0' : ''}`} onClick={() => navigate(`/${tenantSlug}/credits`)} aria-label={c.free ? 'Crédits illimités' : `${c.solde} crédits · ${c.par_mois} inclus ${c.renouvellement_label}`} data-testid={testId} data-keepicon="">
      <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M12 1.5l2.7 7.8 7.8 2.7-7.8 2.7L12 22.5l-2.7-7.8-7.8-2.7 7.8-2.7z" fill="currentColor" /></svg>
      <b data-testid={`${testId}-solde`}>{c.free ? '∞' : c.solde}</b>
    </button>
  );
};

/* M3 · cloche : point orange = décisions non lues · ouvre les notifications (les cartes du fil de tous les modules) */
export const Cloche = ({ testId = 'mg-cloche' }) => {
  const [open, setOpen] = useState(false);
  const d = useNavModules();
  return (
    <>
      <button type="button" className="mg-rd" onClick={() => setOpen(true)} title="Notifications" data-testid={testId} data-keepicon=""><Icone360 k="notifications" size={22} />{(d?.urgentes || 0) > 0 && <u data-testid={`${testId}-point`} />}</button>
      {open && <Notifications42 onClose={() => setOpen(false)} />}
    </>
  );
};

/* M3 · en-tête mobile complet : ‹ · titre · compteur · cloche · ⚙ (le ⚙ ouvre les réglages du module, sur l'Accueil la page Réglages) */
export const EnTeteMobile = ({ titre, retour = true, onRetour, onOutils, testId = 'mg-top', children, avantCredits }) => {
  const navigate = useNavigate();
  const { tenantSlug } = useParams();
  const barre = (
    <div className="mg-top" data-testid={testId}>
      {retour && <button type="button" className="mg-back" onClick={onRetour || (() => navigate(`/${tenantSlug}/dashboard`))} title="Retour" data-testid={`${testId}-retour`} data-keepicon=""><ChevronLeft /></button>}
      <h3 data-nodot="" className={String(titre || '').length > 11 ? 'is-long' : undefined} data-testid={`${testId}-titre`}>{titre}<span className="dot">.</span></h3>
      <span className="sp" />
      {avantCredits}
      {/* LOT 55 v3 · E2 · plus de loupe dans la barre du haut : titre · crédits · cloche */}
      <CompteurCredits testId={`${testId}-credits`} />
      <Cloche testId={`${testId}-cloche`} />
      {children}
      {/* LOT 55 v3 · E2 · les outils de la page passent dans l'en-tête du module (carré réglages) */}
    </div>
  );
    return barre;
};
